import ComplianceReport from "../components/engineering/complianceReport/ComplianceReport";
import DwriDataSearch from "../components/engineering/dwri/DwriDataSearch";

export const engineeringRoutes = [
    {
        path: "/engineering/dwri/dwri-data-search",
        component: DwriDataSearch,
        requiresWaterSystem: true
    },
    {
        path: "/engineering/complianceReport/compliance-report",
        component: ComplianceReport
    }
];
